// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React, { Component } from 'react';
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import formatDate from '../utilities/formatDate';

export default class SelectDate extends Component {

    state = {
        showSelector: false
    }

    render = () => {
        return (<div
            className="config-date-container"
            onClick={() => this.setState({ showSelector: !this.state.showSelector })}
        >
            {formatDate(this.props.value)}
            <div className="config-date-icon" />
            {this.state.showSelector ? <div
                className="config-date-selector"
                onClick={(e) => e.stopPropagation()}
            >
                <Calendar
                    date={this.props.value ? new Date(this.props.value) : new Date()}
                    months={1}
                    direction="horizontal"
                    editableDateInputs={true}
                    onChange={(value) => {
                        this.props.onChange(value);
                        this.setState({ showSelector: false });
                    }}
                />
            </div> : ""}
        </div>);
    }

}